import React from 'react'
import className from 'classnames/bind'

import MyhouseCommonLayout from '../MyhouseCommonLayout'
import MyhouseCommonTitleLayout from '../MyhouseCommonTitleLayout'
import MyhousePrice from '../MyhousePrice'
import MyhouseCommonButton, { BUTTONTYPE } from '../MyhouseCommonButton'

import style from './MyhouseUnitTrendPrice.module.scss'

import ArrowRight7x12 from '@Root/ui/images/myhouse/ArrowRight7x12.svg'
import MyhouseCommonTooltipLayer from '@Components/atoms/MyhouseCommonTooltipLayer'
import { LAND_SERVICE_PREFIX_URL } from '@Root/contants/urlConstants'
import { NCLICK } from '@Root/contants/lcs'
import { handleNclickMix } from '@Helpers/nclick'

const cx = className.bind(style)

type Props = {
  monthlyPriceChangePercent?: any
  detailAddress?: any
  basisDate?: any
  unitTrendPriceMoreInfoHandler?: any
  myhouseAuthHandler?: any
  dealLowerLimitPrice?: any
  dealUpperLimitPrice?: any
  prevYear?: any
  ownerAuth?: boolean
  residentAuth?: boolean
  buildingNo?: any
  hoNo?: any
  isTrendPriceExist?: boolean
  isRegisteredDongHo?: boolean
  houseNo?: any
  isAuthProgress?: boolean
}

const MyhouseUnitTrendPrice: React.FC<Props> = ({
  monthlyPriceChangePercent,
  detailAddress,
  basisDate,
  unitTrendPriceMoreInfoHandler,
  myhouseAuthHandler,
  dealLowerLimitPrice,
  dealUpperLimitPrice,
  ownerAuth,
  residentAuth,
  buildingNo,
  hoNo,
  isTrendPriceExist,
  isRegisteredDongHo,
  houseNo,
  isAuthProgress,
}: Props) => {
  const isInputDongHo = !!buildingNo && buildingNo > 0 && !!hoNo && hoNo > 0
  const isMyHouseTrendPriceDefault = (ownerAuth || residentAuth) && isInputDongHo && isTrendPriceExist && dealUpperLimitPrice && dealLowerLimitPrice
  const isTrendPriceNotExistByMyAddress = (ownerAuth || residentAuth) && isInputDongHo && (!dealLowerLimitPrice || !dealUpperLimitPrice)
  const isDetailAddressEmpty = isTrendPriceExist && (!buildingNo || !hoNo) && isRegisteredDongHo
  const isMyHouseAuthNotCompletion = !ownerAuth && !residentAuth && isRegisteredDongHo && isTrendPriceExist && !isDetailAddressEmpty

  return (
    <>
      {(isMyHouseTrendPriceDefault || isMyHouseAuthNotCompletion || isTrendPriceNotExistByMyAddress || isDetailAddressEmpty) && (
        <>
          <div id="myhouse_unit_trend_price" className={cx('article')}>
            <MyhouseCommonLayout>
              <MyhouseCommonTitleLayout title={'우리집 호별 시세'} description={isMyHouseTrendPriceDefault ? `${basisDate}. 한국부동산원 기준` : ``}>
                <MyhouseCommonTooltipLayer styleTooltip={{ top: '24px' }} title={'호별 시세'} nclickOpen={NCLICK.MY_HOUSE.UNIT_TREND_PRICE.TOOLTIP}>
                  <p className={cx('text')}>
                    본 시세는 한국부동산원 부동산테크 포털에서 제공하는 호별 시세 정보를 기반으로 제공하고 있으며, 해당 포털에서 제공하지 않는 일부 호수의 시세는 네이버페이 부동산에도
                    제공되지 않습니다.
                  </p>
                  <p className={cx('text')}>
                    실거래 가격, 방매 사례 및 시세 도움 중개업소 의견 가격 등을 종합 참작하여 한국부동산원 부동산테크에서 제공하는 시세 범위이며, 개별적인 감정평가액이나 특정
                    실거래 가격 및 민간 업체 시세와는 다소 차이가 날 수 있습니다.
                  </p>
                </MyhouseCommonTooltipLayer>
              </MyhouseCommonTitleLayout>
              {isAuthProgress ? (
                <div className={cx('certify')}>
                  <p className={cx('title')}>우리집 인증을 진행하고 있습니다.</p>
                  <p className={cx('text')}>인증이 완료되면 호별 시세를 확인하실 수 있습니다.</p>
                </div>
              ) : (
                <>
                  {isMyHouseTrendPriceDefault && (
                    <>
                      <MyhousePrice
                        name={detailAddress}
                        price={`${dealLowerLimitPrice} ~ ${dealUpperLimitPrice}`}
                        priceList={
                          monthlyPriceChangePercent != null
                            ? [
                                {
                                  title: '전월 대비',
                                  text: `${monthlyPriceChangePercent}%`,
                                  type: monthlyPriceChangePercent > 0 ? 'plus' : monthlyPriceChangePercent < 0 ? 'minus' : 'same',
                                },
                              ]
                            : null
                        }
                      />
                      <p className={cx('source')}>호별 시세는 한국부동산원 부동산테크로부터 제공받습니다.</p>
                    </>
                  )}
                  {isTrendPriceNotExistByMyAddress && (
                    <>
                      <MyhousePrice name={detailAddress} />
                      <p className={cx('empty')}>
                        해당 호의 시세 정보가 없습니다. <br /> 동일 단지 내 다른 호의 시세를 확인해 주세요.
                      </p>
                    </>
                  )}
                  {isDetailAddressEmpty && (
                    <>
                      <a
                        href={`${LAND_SERVICE_PREFIX_URL.MYHOUSE_REGISTER}/main/${houseNo}`}
                        className={cx('input')}
                        onClick={handleNclickMix(NCLICK.MY_HOUSE.UNIT_TREND_PRICE.DETAIL_ADDRESS)}
                      >
                        상세주소 입력
                        <ArrowRight7x12 />
                      </a>
                      <p className={cx('empty')}>동/호수를 입력하시면 호별 시세를 확인할 수 있어요.</p>
                    </>
                  )}
                  {(isMyHouseTrendPriceDefault || isTrendPriceNotExistByMyAddress || isDetailAddressEmpty) && (
                    <MyhouseCommonButton
                      onClick={handleNclickMix(NCLICK.MY_HOUSE.UNIT_TREND_PRICE.MORE, unitTrendPriceMoreInfoHandler)}
                      buttonType={BUTTONTYPE.LINK_GRAY}
                      buttonText={'우리 단지 호별 시세 더보기'}
                      style={{ marginTop: isTrendPriceNotExistByMyAddress || isDetailAddressEmpty ? 36 : '' }}
                      icon
                    />
                  )}
                  {isMyHouseAuthNotCompletion && (
                    <>
                      <div className={cx('certify')}>
                        <p className={cx('title')}>
                          호별 시세는 <em className={cx('emph')}>우리집 인증</em> 후에
                          <br />
                          제공되는 정보입니다.
                        </p>
                        <p className={cx('text')}>
                          이 집이 우리집이라는 것을 인증하면
                          <br /> 단지 내 모든 호별 시세를 확인할 수 있습니다.
                        </p>
                        <MyhouseCommonButton
                          onClick={handleNclickMix(NCLICK.MY_HOUSE.UNIT_TREND_PRICE.AUTHENTICATION, myhouseAuthHandler)}
                          buttonType={BUTTONTYPE.LINK_GREEN}
                          buttonText={'우리집 인증하기'}
                          style={{ marginTop: 36 }}
                          icon
                        />
                      </div>
                    </>
                  )}
                </>
              )}
            </MyhouseCommonLayout>
          </div>
        </>
      )}
    </>
  )
}

export default MyhouseUnitTrendPrice
